<template>
  <el-col :xs="15" :sm="24" :md="24" :lg="8" :xl="8">
    <el-form-item :label="label" prop="imei">
      <el-upload class="avatar-uploader" action="upload" :show-file-list="false" :auto-upload="false"
        :on-change="change">
        <img v-if="content" :src="content" class="image-service" />
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
    </el-form-item>
  </el-col>
</template>
<script>
import { ServicesService } from "@/services/customers/services.services";
export default {
  name: "UploadLogo",
  props: ['label', 'content'],
  methods: {
    change(file, fileList) { 
      var vm = this;
      console.log('change', file, fileList)
      ServicesService.upload(file)
        .then((response) => {
          vm.$emit("uploaded", {
            token: response.token,
            content: response.content,
          })
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        });
    },
  }
}
</script>
<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 208px;
  height: 120px;
  line-height: 116px;
  text-align: center;
}

.image-service {
  width: 208px;
  height: 120px;
  display: block;
}
</style>
